import React,{Component} from "react";
import CardList from "../Components/CardList";
import SearchBox from "../Components/SearchBox";
import './App.css';
import Scroll from '../Components/Scroll.js';
import Errorboundaries from "../Components/Errorboundaries";


 class App extends Component{
    constructor(){
        super();
        this.state = {
            robots : [],
            searchfield : ''
        }
    }
    componentDidMount(){
        fetch('https://jsonplaceholder.typicode.com/users')
          .then(response => response.json())
          .then(users => this.setState({robots : users}));
    }

    Onsearchchange = (event) => {
        this.setState({
            searchfield : event.target.value 
        })
        
    }

    render(){
        const filterrobots = this.state.robots.filter(robot => {
            return robot.name.toLowerCase().includes(this.state.searchfield.toLowerCase());
        })
        if(this.state.robots.length === 0){
            return <h1>Loading</h1>;
        }
        else{
            return(
                <div className="tc">
                    <h1 >My Robot Friends</h1>
                    <SearchBox SearchBoxname = {this.Onsearchchange}/>
                    <Scroll>
                        <Errorboundaries>
                            <CardList robot = {filterrobots}/>
                        </Errorboundaries>
                    </Scroll>
                </div>
            );
        }
    }

 }

 export default App;